import { t } from "i18next";
import PropTypes from "prop-types";
import { useSnapshot } from "valtio";

import React from "react";

import { kioskStore } from "@pages/Kiosk/store";

export function ContinueOrder(
    props: React.SVGProps<SVGSVGElement>
): JSX.Element {
    const { customerLanguage } = useSnapshot(kioskStore);
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 437 65" {...props}>
            <g
                id="Groupe_55"
                data-name="Groupe 55"
                transform="translate(-37 4055)"
            >
                <g
                    id="Rectangle_7"
                    data-name="Rectangle 7"
                    transform="translate(37 -4055)"
                    fill="#fff"
                    stroke="#141414"
                    strokeWidth="2"
                >
                    <rect
                        width={props.width}
                        height={props.height}
                        rx="9"
                        stroke="none"
                    />
                    <rect
                        x="1"
                        y="1"
                        width={parseInt(props.width as string) - 2}
                        height={parseInt(props.height as string) - 2}
                        rx="8"
                        fill="#fff"
                    />
                </g>
                <text
                    id="Poursuivre_ma_commande"
                    data-name="Poursuivre ma commande"
                    transform="translate(256 -4011)"
                    fill="#141414"
                    fontSize="29"
                    fontFamily="Roboto, sans-serif"
                    textAnchor="middle"
                >
                    {t("Continue my order", {
                        lng: customerLanguage.name,
                    })}
                </text>
            </g>
        </svg>
    );
}
ContinueOrder.propTypes = {
    nameSvg: PropTypes.string,
    width: PropTypes.string,
    height: PropTypes.string,
    pointerEvents: PropTypes.string,
    opacity: PropTypes.string,
    onClick: PropTypes.func,
};
